export const isObjectType = (val) =>
  Object.prototype.toString.call(val) === '[object Object]';
